module.exports = __webpack_public_path__ + "img/SAS_Longsword.8787bd98.png";